import { Timestamp } from 'firebase/firestore';

export const convertFirestoreTimestampToString = (
  timestamp: { _seconds: number; _nanoseconds: number } | Timestamp | null | undefined,
): string => {
  if (!timestamp) return '';
  if (typeof (timestamp as any).toDate === 'function') {
    return (timestamp as Timestamp).toDate().toISOString();
  }
  if ('_seconds' in (timestamp as any)) {
    // eslint-disable-next-line no-underscore-dangle
    return new Date((timestamp as any)._seconds * 1000).toISOString();
  }
  return '';
};
